import * as angular from "angular";
import { DialogUtils } from "../../../../helper/dialog.helper";
import { ToastUtils } from "../../../../helper/toast.helper";
import { DashboardDataProvider } from "../../../../data-provider/dashboard.dp";
import { User } from "../../../../models/user.model";
import { Team } from "../../../../models/team.model";

let WidgetFilterUsersTeamsDialogComponent = {
    selector: "vcWidgetFilterUsersTeamsDialog",
    templateUrl:
        "/angular/components/dashboard/widget/filter/widget-filter-users-teams-dialog.component.html",
    bindings: {
        filter: "=",
        defaultTab: "=?",
        allowUnassigned: "=?",
    },
    controller: class WidgetFilterDialogController {
        // * bindings for typescript compiler *
        public filter: any;
        public defaultTab: string;
        // ************************************
        public saving: boolean = false;
        public dialog: DialogUtils;
        public toast: ToastUtils;
        public dataProvider: DashboardDataProvider;
        public type: string = "team";

        constructor(
            DashboardDataProvider: DashboardDataProvider,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils
        ) {
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.dataProvider = DashboardDataProvider;
        }

        $onInit() {
            if (!this.defaultTab) {
                this.defaultTab = "team";
            }
            if (this.filter.users.length > 0 || this.defaultTab == "user") {
                this.type = "user";
            }
        }

        removeUser(user: User, users: User[]): void {
            angular.forEach(users, (thisUser: User, $index: number) => {
                if (angular.isDefined(user.uid) && user.uid == thisUser.uid) {
                    users.splice($index, 1);
                } else if (
                    user.campaigninviteemail &&
                    user.campaigninviteemail == thisUser.campaigninviteemail
                ) {
                    users.splice($index, 1);
                } else if (
                    user.campaigninvitephonenumber &&
                    user.campaigninvitephonenumber ==
                        thisUser.campaigninvitephonenumber &&
                    user.campaigninvitecountrycode ==
                        thisUser.campaigninvitecountrycode
                ) {
                    users.splice($index, 1);
                }
            });
        }

        removeTeam(team: Team, teams: Team[]): void {
            angular.forEach(teams, (thisTeam: Team, $index: number) => {
                if (team.tid && team.tid === thisTeam.tid) {
                    teams.splice($index, 1);
                }
            });
        }

        cancel() {
            this.dialog.cancel();
        }

        save() {
            this.saving = true;
            if (this.type == "team") {
                this.filter.users = [];
            } else if (this.type == "user") {
                this.filter.teams = [];
            }
            this.dialog.hide(this.filter);
        }
    },
};

angular
    .module("dashboard")
    .component(
        WidgetFilterUsersTeamsDialogComponent.selector,
        WidgetFilterUsersTeamsDialogComponent
    );
